// extracted by mini-css-extract-plugin
export var content = "_50-3";
export var list = "_50-4";
export var settingsContent = "_50-7";
export var settingsPanel = "_50-8";
export var state = "_50-6";
export var triggerBadge = "_50-2";
export var triggerButton = "_50-1";
export var triggerShell = "_50-0";
export var unreadDot = "_50-5";